export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const FETCH_BRAND = 'FETCH_BRAND';
export const FETCH_HEADER_WARNING = 'FETCH_HEADER_WARNING';

export const RESET = 'RESET';

export const SIGN_IN_RESET = 'SIGN_IN_RESET';
export const SIGN_IN_OK = 'SIGN_IN_OK';
export const SIGN_IN_FAILURE = 'SIGN_IN_FAILURE';

export const FETCH_DEVICES = 'FETCH_DEVICES';
export const FETCH_DEVICE = 'FETCH_DEVICE';
export const SEARCH_DEVICES = 'SEARCH_DEVICES';

export const FETCH_PROJECTS = 'FETCH_PROJECTS';
export const FETCH_PROJECT = 'FETCH_PROJECT';
export const RESET_PROJECTS = 'RESET_PROJECTS';
export const FETCH_PROJECT_REPORT = 'FETCH_PROJECT_REPORT';

export const ERROR_PROJECT_NOT_FOUND = 'ERROR_PROJECT_NOT_FOUND';
export const SEARCH_PROJECTS = 'SEARCH_PROJECTS';
export const CREATE_PROJECT = 'CREATE_PROJECT';
export const UPDATE_PROJECT = 'UPDATE_PROJECT';
export const DELETE_PROJECT = 'DELETE_PROJECT';
export const VERIFY_PROJECT = 'VERIFY_PROJECT';
export const GENERATE_PROJECT = 'GENERATE_PROJECT';
export const DOWNLOAD_PROJECT = 'DOWNLOAD_PROJECT';
export const SET_TEMPORARY_PROJECT = 'SET_TEMPORARY_PROJECT';
export const IMPORT_PROJECT = 'IMPORT_PROJECT';
export const RESET_PROJECT = 'RESET_PROJECT';
export const COPY_PROJECT = 'COPY_PROJECT';
export const FETCH_PROJECT_LOCATION = 'FETCH_PROJECT_LOCATION';
export const UPDATE_PROJECT_LOCATION = 'UPDATE_PROJECT_LOCATION';
export const FETCH_ALL_VERSIONS = 'FETCH_ALL_VERSIONS';

export const ADD_DRIVER = 'ADD_DRIVER';
export const ADD_DRIVER_BY_GTIN = 'ADD_DRIVER_BY_GTIN';
export const FETCH_DRIVERS = 'FETCH_DRIVERS';
export const FETCH_DRIVER = 'FETCH_DRIVER';
export const FETCH_DRIVER_PROPERTIES = 'FETCH_DRIVER_PROPERTIES';
export const FETCH_DRIVER_DEFAULTS = 'FETCH_DRIVER_DEFAULTS';
export const FETCH_DRIVER_OPMODES = 'FETCH_DRIVER_OPMODES';
export const FETCH_DRIVER_OPMODES_SELECTED = 'FETCH_DRIVER_OPMODES_SELECTED';
export const UPDATE_DRIVER_OPMODES_SELECTED = 'UPDATE_DRIVER_OPMODES_SELECTED';
export const FETCH_DRIVER_FEATURES = 'FETCH_DRIVER_FEATURES';
export const FETCH_DRIVER_PERMISSIONS = 'FETCH_DRIVER_PERMISSIONS';
export const FETCH_LOCKED_FEATURES = 'FETCH_LOCKED_FEATURES';
export const FETCH_DRIVER_COUNT = 'FETCH_DRIVER_COUNT';
export const UPDATE_DRIVER_COUNT = 'UPDATE_DRIVER_COUNT';
export const UPDATE_DRIVERS = 'UPDATE_DRIVERS';
export const FETCH_DRIVER_PROGRAMMING_SELECTION = 'FETCH_DRIVER_PROGRAMMING_SELECTION';
export const UPDATE_DRIVER_PROGRAMMING_SELECTION = 'UPDATE_DRIVER_PROGRAMMING_SELECTION';
export const UPDATE_DRIVER_PROGRAMMING_SINGLE_SELECTION = 'UPDATE_DRIVER_PROGRAMMING_SINGLE_SELECTION';
export const RESET_DRIVER = 'RESET_DRIVER';
export const UPDATE_DRIVER = 'UPDATE_DRIVER';
export const DELETE_DRIVER = 'DELETE_DRIVER';
export const FETCH_ASTRO_SAVINGS = 'FETCH_ASTRO_SAVINGS';

export const SEARCH_STARTED = 'SEARCH_STARTED';
export const SEARCH_ENDED = 'SEARCH_ENDED';
export const SEARCH_PARAM_CHANGED = 'SEARCH_PARAM_CHANGED';

export const FETCH_LUMINFOS = 'FETCH_LUMINFOS';
export const GET_TYPE_LUMINFOS = 'GET_TYPE_LUMINFOS';
export const UPDATE_TYPE_LUMINFOS = 'UPDATE_TYPE_LUMINFOS';
export const FETCH_PROPERTIES_LUMINFOS = 'FETCH_PROPERTIES_LUMINFOS';
export const UPDATE_PROPERTIES_LUMINFOS = 'UPDATE_PROPERTIES_LUMINFOS';

export const ERROR_ADD = 'ERROR_ADD';
export const ERROR_REMOVE = 'ERROR_REMOVE';
export const ERROR_DELETE = 'ERROR_DELETE';
export const NOT_FOUND_ERROR_REMOVE = 'NOT_FOUND_ERROR_REMOVE';
export const ALL_ERRORS_REMOVE = 'ALL_ERRORS_REMOVE';

export const NOT_SAVED_PROJECT = 'NOT_SAVED_PROJECT';
export const NOT_SAVED_PROJECT_REMOVE = 'NOT_SAVED_PROJECT_REMOVE';

export const FETCH_PROJECT_OPTIONS = 'FETCH_PROJECT_OPTIONS';
export const UPDATE_PROJECT_OPTIONS = 'UPDATE_PROJECT_OPTIONS';

export const LUMINAIRE_IMAGE_PROJECT = 'LUMINAIRE_IMAGE_PROJECT';

export const FETCH_LEDMODULES = 'FETCH_LEDMODULES';
export const GET_SELECTED_LEDMODULES = 'GET_SELECTED_LEDMODULES';
export const UPDATE_SELECTED_LEDMODULES = 'UPDATE_SELECTED_LEDMODULES';
export const FETCH_PROPERTIES_LEDMODULES = 'FETCH_PROPERTIES_LEDMODULES';
export const UPDATE_PROPERTIES_LEDMODULES = 'UPDATE_PROPERTIES_LEDMODULES';
